export default __webpack_public_path__ + "static/media/background_login.4493367b.png";